import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    filterConstants,
    LoadingAction,
    ErrorMessageAction,
    accessConstants,
    authUtils,
    LoadQuestionsAction,
    LoadQuestionPracticeSkillsAction,
    LoadUsersAction,
    LoadLessonAction,
    LoadResponsesAction,
    LoadScheduleAction,
    LoadResponsePointsAction,
    LoadPracticeSkillsAction
} from "mindsets-js-sdk";

import '../Scoring/scoring.scss';
import Users from "../Scoring/components/Users";
import Forbidden from "../Forbidden";
import ApproveButton from "./components/ApproveButton";
import SendBackButton from "./components/SendBackButton";
import List from "./components/List";

function getResponsePointsDebounced(getResponsePoints) {
    return _.debounce(getResponsePoints, 5 * 1000)
}

export default function () {
    const me = useSelector(state => state.me);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const lesson = useSelector(state => state.lesson);
    const lesson_scoring_schedule = useSelector(state => state.lesson_scoring_schedule);
    const [membersOnline, setMembersOnline] = useState([]);

    function getResponsePoints() {
        dispatch(LoadResponsePointsAction({
            'filters[lesson_scoring_schedule_id][0]': filterConstants.EXPRESSION_EQUAL + '=' + params.schedule_id,
            'filters[is_qa][0]': filterConstants.EXPRESSION_TRUE,
            'selectors[0]': 'response',
            limit: 0
        }));
    }

    useEffect(() => {
        dispatch(LoadScheduleAction(params.schedule_id, {'selectors[1]': 'practice'}))
            .then(schedule => {
                dispatch(LoadResponsesAction({
                    'filters[lesson_id][0]': filterConstants.EXPRESSION_EQUAL + '=' + schedule.lesson_id,
                    'filters[created_at][0]': filterConstants.EXPRESSION_LT + '=' + new Date(schedule.created_at * 1000).toISOString(),
                    'filters[with_trashed][0]': filterConstants.EXPRESSION_TRUE,
                    limit: 0
                }));

                return dispatch(LoadLessonAction(schedule.lesson_id, {'selectors[0]': 'challenge_code'})).then(lesson => {
                    dispatch(LoadPracticeSkillsAction({
                        'filters[practice_id][0]': filterConstants.EXPRESSION_EQUAL + '=' + schedule.practice_id,
                        'filters[subject][0]': filterConstants.EXPRESSION_EQUAL + '=' + lesson.challenge_version.challenge_code.subject,
                        limit: 0
                    }));
                    dispatch(LoadQuestionPracticeSkillsAction({
                        'filters[challenge_code][0]': filterConstants.EXPRESSION_EQUAL + '=' + lesson.challenge_version.challenge_code.code,
                        'filters[practice_id][0]': filterConstants.EXPRESSION_EQUAL + '=' + schedule.practice_id,
                        limit: 0
                    }));
                    dispatch(LoadQuestionsAction({
                        'filters[challenge_version_id][0]': filterConstants.EXPRESSION_EQUAL + '=' + lesson.challenge_version_id,
                        'selectors[0]': 'is_bonus',
                        'selectors[2]': 'poll_poll_options',
                        'selectors[3]': 'spreadsheet',
                        limit: 0
                    }));
                });
            })
            .catch(error => {
                dispatch(LoadingAction(false));
                dispatch(ErrorMessageAction(error));
                console.error(error);
            });
        getResponsePoints();
    }, []);
    useEffect(() => {
        const channel = pusher.subscribe('presence-grading-schedule-' + params.schedule_id);
        channel.bind('pusher:subscription_succeeded', data => setMembersOnline(Object.keys(data.members).filter(id => parseInt(id) !== me.id).map(id => parseInt(id))));
        channel.bind('pusher:subscription_error', error => {
            console.error(error);
        });
        channel.bind('pusher:member_added', member => {
            if (parseInt(member.id) !== me.id && !membersOnline.includes(parseInt(member.id))) {
                let membersOnline_new = JSON.parse(JSON.stringify(membersOnline));
                membersOnline_new.push(parseInt(member.id));
                setMembersOnline(membersOnline);
            }
        });
        channel.bind('pusher:member_removed', member => {
            let membersOnline_new = JSON.parse(JSON.stringify(membersOnline));
            if (membersOnline_new.includes(parseInt(member.id))) {
                membersOnline_new.splice(membersOnline.indexOf(parseInt(member.id)), 1);
                setMembersOnline(membersOnline);
            }
        });

        return () => channel.unsubscribe();
    }, []);
    useEffect(() => {
        if (membersOnline.length) {
            dispatch(LoadUsersAction({
                'filters[id_online][0]': filterConstants.EXPRESSION_IN + '=' + membersOnline.join(',')
            }));
        }
    }, [membersOnline]);

    if (!me || !(lesson && Object.keys(lesson).length > 0) || !lesson_scoring_schedule) {
        return null;
    }
    if (authUtils.iCant(me, [accessConstants.PERMISSION_CAN_VERIFY_GRADING])) {
        return <Forbidden/>;
    }

    return (
        <>
            <title>QA</title>
            <h1 className='container'>Students scoring for the class {lesson.code.toUpperCase()} of the
                v{lesson.challenge_version.version} of the
                challenge {lesson.challenge_version.name} by a Rubric based
                on {lesson_scoring_schedule.practice.name} set of skills</h1>
            <div className='container d-flex justify-content-between'>
                <button className="button" onClick={event => {
                    event.preventDefault();
                    navigate(-1);
                }}>{'<<'} Back
                </button>
                <Link
                    to={`/challenges/${lesson.challenge_version.challenge_code.code}/practice/${lesson_scoring_schedule.practice_id}/preview`}
                    target='_blank' className="button">Open Rubric</Link>
                <SendBackButton/>
                <ApproveButton/>
            </div>
            <Users/>
            <List getResponsePoints={getResponsePointsDebounced(getResponsePoints)}/>
        </>
    );
}
